import { useCallback, useEffect, useState } from "react";
import api from "../../../services/api";
import { useNotification } from "../../../context/NotificationContext";
import {
  FaStar,
  FaTrash,
  FaEye,
  FaEyeSlash,
  FaThumbtack,
  FaCheckCircle,
} from "react-icons/fa";

function ReviewsAdmin() {
  const { showNotification, confirmAction } = useNotification();
  const [reviews, setReviews] = useState([]);

  const token = localStorage.getItem("token");

  const fetchReviews = useCallback(async () => {
    const res = await api.get("/reviews/admin/all", {
      headers: { Authorization: `Bearer ${token}` },
    });
    setReviews(res.data);
  }, [token]);

  useEffect(() => {
    fetchReviews().catch(console.error);
  }, [fetchReviews]);

  const updateReview = async (reviewId, data) => {
    try {
      await api.put(`/reviews/admin/${reviewId}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchReviews();
      showNotification("הביקורת עודכנה בהצלחה", "success");
    } catch (error) {
      console.error(error);
      showNotification("עדכון הביקורת נכשל", "error");
    }
  };

  const deleteReview = async (reviewId) => {
    const confirmed = await confirmAction({
      title: "מחיקת ביקורת",
      message: "האם למחוק את הביקורת? הפעולה אינה ניתנת לביטול.",
      confirmText: "מחיקה",
    });
    if (!confirmed) return;

    try {
      await api.delete(`/reviews/admin/${reviewId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchReviews();
      showNotification("הביקורת נמחקה בהצלחה", "success");
    } catch (error) {
      console.error(error);
      showNotification("מחיקת הביקורת נכשלה", "error");
    }
  };

  const approvedCount = reviews.filter((review) => review.is_approved === 1).length;
  const featuredCount = reviews.filter((review) => review.is_featured === 1).length;

  return (
    <section className="dashboard-section reviews-section">
      <div className="section-title">
        <div className="section-title-main">
          <span className="section-icon"><FaStar /></span>
          <div>
            <h2>ניהול ביקורות</h2>
            <p>אישור, הסתרה והבלטה של חוות דעת לקוחות</p>
          </div>
        </div>
        <span className="section-count">{reviews.length} ביקורות</span>
      </div>

      <div className="admin-mini-stats review-mini-stats">
        <div><strong>{reviews.length}</strong><span>סה״כ ביקורות</span></div>
        <div><span className="mini-stat-icon"><FaCheckCircle /></span><strong>{approvedCount}</strong><span>מוצגות באתר</span></div>
        <div><span className="mini-stat-icon"><FaThumbtack /></span><strong>{featuredCount}</strong><span>מומלצות</span></div>
      </div>

      {reviews.length === 0 ? (
        <div className="empty-state-card"><FaStar /><h3>אין ביקורות להצגה</h3><p>ביקורות חדשות יופיעו כאן לניהול.</p></div>
      ) : (
        <div className="admin-reviews-list">
          {reviews.map((review) => (
            <article className="admin-review-card" key={review.review_id}>
              <div className="admin-review-header">
                <div className="review-customer-info">
                  <span className="review-avatar">{String(review.first_name || "?").charAt(0)}</span>
                  <div>
                    <h3>{review.first_name} {review.last_name}</h3>
                    <small>{review.email}</small>
                  </div>
                </div>

                <div className="admin-review-stars">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar key={star} className={star <= review.rating ? "filled" : ""} />
                  ))}
                </div>
              </div>

              <blockquote>{review.comment}</blockquote>

              <div className="review-admin-badges">
                <span className={review.is_approved === 1 ? "review-approved" : "review-hidden"}>
                  {review.is_approved === 1 ? "מוצגת באתר" : "מוסתרת"}
                </span>
                {review.is_featured === 1 && <span className="review-featured">ביקורת מומלצת</span>}
              </div>

              <div className="review-card-footer">
                <small>{new Date(review.review_date).toLocaleDateString("he-IL")}</small>
                <div className="review-admin-actions">
                  <button
                    onClick={() => updateReview(review.review_id, {
                      is_approved: review.is_approved === 1 ? 0 : 1,
                      is_featured: review.is_featured,
                    })}
                  >
                    {review.is_approved === 1 ? <FaEyeSlash /> : <FaEye />}
                    {review.is_approved === 1 ? "הסתרה" : "הצגה"}
                  </button>

                  <button
                    onClick={() => updateReview(review.review_id, {
                      is_approved: review.is_approved,
                      is_featured: review.is_featured === 1 ? 0 : 1,
                    })}
                  >
                    <FaThumbtack />
                    {review.is_featured === 1 ? "הסרת מומלץ" : "הגדרה כמומלץ"}
                  </button>

                  <button className="danger" onClick={() => deleteReview(review.review_id)}>
                    <FaTrash /> מחיקה
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

export default ReviewsAdmin;
